import { render, staticRenderFns } from "./SelectTrip.vue?vue&type=template&id=0b9a53de&scoped=true&lang=html&"
import script from "./SelectTrip.vue?vue&type=script&lang=js&"
export * from "./SelectTrip.vue?vue&type=script&lang=js&"
import style0 from "./SelectTrip.vue?vue&type=style&index=0&id=0b9a53de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9a53de",
  null
  
)

export default component.exports